var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getArray } from './qbo-json.js';
import { QboFetch } from './qbo-fetch.js';
let QboDataList = class QboDataList extends QboFetch {
    constructor() {
        super(...arguments);
        this.listId = null;
        this.min = 3;
        this.options = [];
        this.renderInHost = true;
        this.text = null;
        this.value = null;
        this.fetchOnLoad = false;
        this.endpoint = null;
        this.headers = null;
        this.payload = {};
        this.targets = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.targets = document.querySelectorAll(`input[list=${this.listId}]`);
        const el = this;
        this.targets.forEach(function (target) {
            target.addEventListener('keyup', el.buildDataList.bind(el));
            if (target.hasAttribute('data-for'))
                target.addEventListener('change', el.setOutputValue.bind(el));
        });
        this.endpoint = this.apiEndpoint.toString();
        this.headers = this.getHeaders();
        this.payload = this.getPayload(this.headers);
    }
    disconnectedCallback() {
        const el = this;
        this.targets?.forEach(function (target) {
            target.removeEventListener('keyup', el.buildDataList.bind(el));
            if (target.hasAttribute('data-for'))
                target.removeEventListener('change', el.setOutputValue.bind(el));
        });
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    async buildDataList(e) {
        const target = e.target;
        if (target instanceof HTMLInputElement) {
            if (target.value.length >= this.min) {
                if (this.endpoint != null)
                    this.apiEndpoint = new URL(this.endpoint.replace('{value}', `${target.value}`), this.baseURI);
                await this.fetchData(this.headers, this.payload);
            }
        }
    }
    setOutputValue(e) {
        const target = e.target;
        let targetFor = null;
        if (target.hasAttribute('data-for')) {
            const attribute = target.getAttribute('data-for');
            targetFor = document.getElementById(attribute)
                || target.querySelector(attribute)
                || target.parentElement?.querySelector(attribute)
                || document.getElementsByName(attribute)[0];
        }
        if (target instanceof HTMLInputElement && targetFor instanceof HTMLInputElement) {
            const text = this.text;
            const result = this.options?.filter(function (j) { return j[text] == target.value; });
            target.value = result?.length == 1 ? result[0][`${this.text}`] : '';
            targetFor.value = result?.length == 1 ? result[0][`${this.value}`] : '';
        }
    }
    render() {
        this.options = getArray(this.jsonData);
        if (!this.options || this.options.length === 0)
            return html ``;
        if (this.options != null) {
            this.value ??= Object.keys(this.options[0])[0];
            this.text ??= Object.keys(this.options[0])[1] ?? this.value;
        }
        return html `
            <datalist id=${this.listId}>
                ${this.options.map(option => html `<option value="${option[this.text]}" data-value="${option[this.value]}"/>`)}
            </datalist>`;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboDataList.prototype, "listId", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboDataList.prototype, "min", void 0);
__decorate([
    property({ type: Array }),
    __metadata("design:type", Object)
], QboDataList.prototype, "options", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDataList.prototype, "renderInHost", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboDataList.prototype, "text", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboDataList.prototype, "value", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboDataList.prototype, "fetchOnLoad", void 0);
QboDataList = __decorate([
    customElement('qbo-datalist')
], QboDataList);
export { QboDataList };
